import React, { useState } from "react";

/**
 * Founder video — portrait Vimeo embed in CORSA's rounded-15 frame.
 * Click-to-play. Uses the supplied portrait wrapper ratio (177.78% = 9:16).
 */
export const FounderVideo = ({
  src = "https://player.vimeo.com/video/1202328126?h=9120383b84&badge=0&autopause=0&player_id=0&app_id=58479",
  title = "We Are Corsa",
  poster,
  className = "",
  dataTestId = "founder-video",
}) => {
  const [active, setActive] = useState(false);
  const finalSrc = active
    ? `${src}${src.includes("?") ? "&" : "?"}autoplay=1`
    : null;

  return (
    <div
      className={`relative w-full curve-frame ${className}`}
      style={{
        borderRadius: 15,
        background: "#000",
        border: "3px solid var(--track)",
        boxShadow: "8px 8px 0 0 var(--track)",
        overflow: "hidden",
      }}
      data-testid={dataTestId}
    >
      <div style={{ padding: "177.78% 0 0 0", position: "relative" }}>
        {!active && (
          <button
            type="button"
            onClick={() => setActive(true)}
            aria-label={`Play ${title}`}
            data-testid={`${dataTestId}-play`}
            className="absolute inset-0 w-full h-full group"
            style={{ background: "#000" }}
          >
            {poster && (
              <img
                src={poster}
                alt={title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover"
              />
            )}
            <div className="absolute inset-0 flex items-center justify-center bg-black/15 group-hover:bg-black/25 transition-colors">
              <span
                className="relative flex items-center justify-center"
                style={{
                  width: 84,
                  height: 84,
                  borderRadius: "9999px",
                  background: "var(--calypso)",
                  border: "3px solid var(--track)",
                  boxShadow: "6px 6px 0 0 var(--track)",
                }}
              >
                <svg width="26" height="30" viewBox="0 0 24 28" fill="var(--track)" aria-hidden="true">
                  <path d="M2 2 L22 14 L2 26 Z" />
                </svg>
              </span>
            </div>
          </button>
        )}
        {active && (
          <iframe
            title={title}
            src={finalSrc}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
            data-testid={`${dataTestId}-iframe`}
          />
        )}
      </div>
    </div>
  );
};

export default FounderVideo;
